import { StyleSheet } from 'react-native';
import Confetti from 'components/atoms/Confetti'
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedLayout from 'components/atoms/ThemedLayout'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";

const DebugVideo = () => {
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					<ThemedBlock
						style={staticStyles.themedBlockWidth100Height150}>
						
						<Confetti />
					</ThemedBlock>
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

const staticStyles = StyleSheet.create({
	themedBlockWidth100Height150: {
		width: '100%',
		height: 150,
	},
});

export default DebugVideo
